import { useMemo } from 'react';
import { PumoModuleFragment } from '../../generated/types';

const isAmexBannerModule = (module: PumoModuleFragment) =>
  module.name?.trim().toLowerCase() === 'amex banner';

export const useSwitchAmexModules = (modules: PumoModuleFragment[]) => {
  return useMemo(() => modules.filter(module => !isAmexBannerModule(module)), [modules]);
};
